// Строка перечисления и контейнер с разделителями (D-27, §2.4).
// Source: docs/specs/design-revision/d-design-system.md §2.4.
//
// Пункт списка «иконка — заголовок — пояснение». Сейчас такие списки собраны
// вручную в Профиле через divide-y, а на лендинге вместо них стоят карточки —
// один и тот же смысл двумя разными способами.

import type { ReactNode } from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ListRowGroup({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={cn(
        'divide-y divide-border overflow-hidden rounded-surface border border-border bg-surface',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function ListRow({
  icon,
  title,
  description,
  trailing,
  onClick,
  className,
}: {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** Своё содержимое справа. По умолчанию у кликабельной строки — шеврон. */
  trailing?: ReactNode;
  onClick?: () => void;
  className?: string;
}) {
  const Tag = onClick ? 'button' : 'div';

  return (
    <Tag
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      className={cn(
        'flex w-full items-center gap-3 px-3.5 py-3 text-left',
        onClick && 'transition hover:bg-muted',
        className,
      )}
    >
      {icon}
      <span className="min-w-0 flex-1">
        <span className="block text-hl-body font-semibold text-foreground">{title}</span>
        {description && (
          <span className="block text-hl-small text-muted-foreground">{description}</span>
        )}
      </span>
      {trailing ??
        (onClick ? (
          <ChevronRight className="h-4 w-4 flex-shrink-0 text-muted-foreground" aria-hidden="true" />
        ) : null)}
    </Tag>
  );
}
